import React, { Component } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import CookieManager from '../managers/CookieManager';
import { 
    ShoppingCart, 
    People, 
    Inventory, 
    Storefront, 
    AccountCircle, 
    Info, 
    Gavel, 
    Login, 
    Logout,
    Email 
} from '@mui/icons-material';

import Events from '../service/Events';

import LocalStorageManager from '../managers/LocalStorageManager';

class Navigation extends Component {
    NavLinkWithIcon = ({ href, icon: Icon, label, isActive = false }) => (
        <Nav.Link 
            href={href} 
            style={{ 
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: window.innerWidth < 600 ? '5px' : '6px',
                padding: window.innerWidth < 600 ? '6px 10px' : '8px 12px',
                borderRadius: '8px',
                fontSize: window.innerWidth < 600 ? '0.9rem' : '1rem',
                transition: 'all 0.2s ease',
                background: isActive ? 'rgba(255, 255, 255, 0.12)' : 'transparent',
                position: 'relative'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = isActive ? 'rgba(255, 255, 255, 0.12)' : 'transparent';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
        >
            <Icon sx={{ fontSize: window.innerWidth < 600 ? '1rem' : '1.2rem' }} />
            <span>{label}</span>
            {isActive && (
                <div style={{
                    position: 'absolute',
                    bottom: '0',
                    left: '12px',
                    right: '12px',
                    height: '2px',
                    background: '#c8e6c9',
                    borderRadius: '2px 2px 0 0'
                }} />
            )}
        </Nav.Link>
    );

    RenderNavigation() {
        const currentPath = window.location.pathname;
        
        switch (LocalStorageManager.Get("admin")) {
            case "1":
                return (
                    <>
                        <this.NavLinkWithIcon 
                            href="/dashboard" 
                            icon={ShoppingCart} 
                            label="Warenkorb"
                            isActive={currentPath === '/dashboard'}
                        />
                        <this.NavLinkWithIcon 
                            href="/dashboardCustomers" 
                            icon={People} 
                            label="Kunden"
                            isActive={currentPath === '/dashboardCustomers'}
                        />
                        <this.NavLinkWithIcon 
                            href="/dashboardProducts" 
                            icon={Inventory} 
                            label="Produktübersicht"
                            isActive={currentPath === '/dashboardProducts'}
                        />
                        <this.NavLinkWithIcon 
                            href="/dashboardEmail" 
                            icon={Email} 
                            label="E-Mail"
                            isActive={currentPath === '/dashboardEmail'}
                        />
                    </>
                );
            case "0":
                return (
                    <this.NavLinkWithIcon 
                        href="/dashboard" 
                        icon={ShoppingCart} 
                        label="Warenkorb"
                        isActive={currentPath === '/dashboard'}
                    />
                );
            default:
                return (
                    <this.NavLinkWithIcon 
                        href="/dashboard" 
                        icon={ShoppingCart} 
                        label="Warenkorb"
                        isActive={currentPath === '/dashboard'}
                    />
                );
        }
    }

    signOut() {
        CookieManager.Delete("auth");
        LocalStorageManager.DeleteMultiple(["admin", "isSaved", "password", "email"]);

        window.location.reload();
    }

    signIn() {
        Events.onResult.emit("onAuthTokenInvalid");
    }

    render() {
        return (
            <Navbar 
                collapseOnSelect 
                expand="lg" 
                variant="dark" 
                sticky="top"
                style={{
                    background: 'linear-gradient(135deg, #2e7d32 0%, #388e3c 100%)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    padding: window.innerWidth < 600 ? '8px 0' : '12px 0'
                }}
            >
                <Container fluid style={{ paddingLeft: window.innerWidth < 600 ? '12px' : '20px', paddingRight: window.innerWidth < 600 ? '12px' : '20px' }}>
                    <Navbar.Brand 
                        href="/" 
                        style={{ 
                            fontWeight: 700, 
                            fontSize: window.innerWidth < 600 ? '1.2rem' : '1.5rem',
                            fontFamily: 'Inter, sans-serif',
                            marginRight: window.innerWidth < 600 ? '10px' : '30px'
                        }}
                    >
                        Maro - Food
                        <span style={{ 
                            color: "#c8e6c9", 
                            fontWeight: 400, 
                            fontSize: window.innerWidth < 600 ? '0.75rem' : '0.9rem',
                            display: window.innerWidth < 400 ? 'none' : 'inline'
                        }}> (Bestell Food Coop)</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto" style={{ gap: '4px', flex: 1 }}>
                            {this.RenderNavigation()}
                            
                            {/* Divider */}
                            <div style={{ 
                                width: '1px', 
                                height: '24px', 
                                background: 'rgba(255, 255, 255, 0.2)', 
                                margin: '0 8px',
                                alignSelf: 'center'
                            }} />
                            
                            <this.NavLinkWithIcon 
                                href="/" 
                                icon={Storefront} 
                                label="Produkte"
                                isActive={window.location.pathname === '/'}
                            />
                            <this.NavLinkWithIcon 
                                href="/account" 
                                icon={AccountCircle} 
                                label="Account"
                                isActive={window.location.pathname === '/account'}
                            />
                            
                            {/* Divider */}
                            <div style={{ 
                                width: '1px', 
                                height: '24px', 
                                background: 'rgba(255, 255, 255, 0.2)', 
                                margin: '0 8px',
                                alignSelf: 'center'
                            }} />
                            
                            <this.NavLinkWithIcon 
                                href="/info" 
                                icon={Info} 
                                label="Hinweise"
                                isActive={window.location.pathname === '/info'}
                            />
                            <this.NavLinkWithIcon 
                                href="/impressum" 
                                icon={Gavel} 
                                label="Impressum"
                                isActive={window.location.pathname === '/impressum'}
                            />
                        </Nav>
                        <Nav style={{ marginLeft: 'auto' }}>
                            {
                                CookieManager.Get("auth")
                                    ?
                                    (
                                        <Nav.Link 
                                            onClick={this.signOut}
                                            style={{
                                                fontWeight: 600,
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                borderRadius: '10px',
                                                padding: '8px 16px',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                border: '1px solid rgba(255, 255, 255, 0.2)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <Logout sx={{ fontSize: '1.1rem' }} />
                                            <span>Ausloggen</span>
                                        </Nav.Link>
                                    )
                                    :
                                    (
                                        <Nav.Link 
                                            onClick={this.signIn}
                                            style={{
                                                fontWeight: 600,
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                borderRadius: '10px',
                                                padding: '8px 16px',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                border: '1px solid rgba(255, 255, 255, 0.2)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <Login sx={{ fontSize: '1.1rem' }} />
                                            <span>Anmelden</span>
                                        </Nav.Link>
                                    )
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        )
    }
}

export default Navigation;